import { queryOptions } from '@tanstack/vue-query'
import { fetchProducts } from '@/features/projects/api/fetchProducts'

export const fetchProductsQueryOptions = () => queryOptions({
  queryKey: ['products'],
  queryFn: () => fetchProducts(),
})
